import http from '../plugins/http'
import {GROUP} from '../config/config_api_backend'
import stringInject from 'stringinject'


const getAllGroups = async (params) => {
    try {
        let response = await http.get(GROUP.GET_GROUP_ALL, {
            params
        })
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const apiCreateGroup = async (file, info) => {
    try {
        const formData = new FormData()
        if (file != null) {
            formData.append('file', file)
        }
        formData.append('name', info.name)
        formData.append('description', info.description)
        formData.append('isInternet', info.isCheckInternet)

        let response = await http.put(GROUP.PUT_GROUP,
            formData,
            {'Content-Type': 'multipart/form-data'})
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const apiUpdateGroup = async (id, groupInfo) => {
    let url = stringInject(GROUP.UPDATE_GROUP, {'id': id})
    let formData = new FormData()
    formData.append('description', groupInfo.description)
    formData.append('name', groupInfo.name)
    try {
        let response = await http.post(url, formData,
            {
                'Content-Type': 'multipart/form-data'
            })
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const getGroupInfo = async (id) => {
    try {
        let url = stringInject(GROUP.GET_GROUP_INFO, {'id': id})
        let response = await http.get(url)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const apiAppendFiles = async (files, groupId) => {
    try {
        const formData = new FormData()
        if (files != null) {
            files.forEach(file => {
                formData.append('files', file)
            })
        }
        formData.append('groupId', groupId)

        let response = await http.post(GROUP.APPEND_DOCUMENT,
            formData,
            {'Content-Type': 'multipart/form-data'})
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const apiDeleteGroupDocument = async (groupId, documentIds) => {

    try {
        let url = stringInject(GROUP.DELETE_DOCUMENT, {'groupId': groupId})
        let response = await http.delete(url, {params: {documentIds: documentIds.join(',')}})
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}


export {
    getAllGroups,
    apiCreateGroup,
    apiUpdateGroup,
    getGroupInfo,
    apiAppendFiles,
    apiDeleteGroupDocument,
}
